import type { FC } from 'react'

import {
  actionsSelector,
  displayRecordingStatementSelector,
  useStore,
} from '@liveHelper/models/store'
import { Close } from '@oneToOne/shared/assets/Close'

import { ControlsButton } from '@core/components/ControlsButton/ControlsButton'
import { useContextTranslation } from '@core/i18n'

import {
  RecordingStatementContainer,
  RecordingStatementText,
} from './RecordingStatement.styles'

interface Props {
  isOverlayOnChat?: boolean
}

/**
 * A component for rendering the legal statement for recording calls.
 */
export const RecordingStatement: FC<Props> = ({ isOverlayOnChat = false }) => {
  const { t } = useContextTranslation()
  const displayRecordingStatement = useStore(displayRecordingStatementSelector)
  const { hideRecordingStatement } = useStore(actionsSelector)

  if (displayRecordingStatement) {
    return (
      <RecordingStatementContainer isOverlayOnChat={isOverlayOnChat}>
        <RecordingStatementText>
          {t('oneToOne:For legal purposes, the call might be recorded')}
        </RecordingStatementText>
        <ControlsButton
          src={
            <Close
              height="10px"
              width="10px"
              fill="var(--white)"
              aria-hidden
              label=""
            />
          }
          size={24}
          onClick={hideRecordingStatement}
          aria-label={t('oneToOne:Close Recording Statement')}
        />
      </RecordingStatementContainer>
    )
  }

  return null
}
